import CommonUtils from './common-utils';




export default class AdLogs { 
    // 페이스북 픽셀 이벤트로그 전송 (시크린 전용)
    static sendMetaPixelEventLogs(eventName: string, data: Map<string, any> | object){
        // 시크린이 아닐 경우 종료
        ////if(CommonUtils.isSystemLocale('global') != true) return;

        const _window = (window as any);

        // 페이스북 픽셀 이벤트로그 관련 객체 없을 경우 종료
        if(_window.fbq == null) return;

        switch(eventName) {
            case 'AddToCart' :
            case 'ViewContent' :
            case 'CompleteRegistration':
            case 'InitiateCheckout' :
                _window.fbq('track', eventName, data);
                break;
            case 'Purchase' :
                _window.fbq('track', 'Purchase', data, {eventID: `${data["content_ids"]}`});
                break;
            case 'Purchase_Sec' :
                _window.fbq('trackCustom', 'Purchase_Sec', data, {eventID: `${data["content_ids"]}`});
                break;
        }  
    }

    static sendKakaoPixelEventLogs(eventName: string, data: Map<string,any>| object) {
        const _window = (window as any);
        
        if(_window.kakaoPixel == null) return;
        switch(eventName) {
            case 'Purchase':
                _window.kakaoPixel('9012487525814847947').pageView();
                _window.kakaoPixel('9012487525814847947').purchase(data);
                break;
        }
    }

    // 구글 GTag 이벤트로그 전송 (시크린 전용) -> 파이어베이스로 대체함
    /*
    static sendGTagEventLogs(eventName: string, data: Map<string, any>){
        return;
    }
    */
}